/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React from "react";
import {service as SpeciesListService} from "../../../Services/SpeciesListService";
import {ServiceDrivenFieldViewer} from "./ServiceDrivenFieldViewer";
import {StreamBankLink} from "../../../Components/Common/StreamBankLink";


const _SpeciesListFieldViewer = ServiceDrivenFieldViewer(SpeciesListService);

export const SpeciesListFieldViewer = (props) => {
	const {Value, RootData} = props;
	const assignedSpeciesListId = Value ?? RootData?.parentAssignedSpeciesListId;
	
	// SubProgram will have a value and Project will have undefined
	const speciesListIsOptional = (RootData?.parentProgramId !== null);
	const isDefaultSuffix = (Value == null && speciesListIsOptional) ? <div className="sb-sub-text">(Default)</div> : null
	
	return <StreamBankLink
		Href={`/speciesLists/${assignedSpeciesListId}`}
		target={"_blank"}
	><_SpeciesListFieldViewer
		{...props}
		Value={assignedSpeciesListId}
		titleSuffix={isDefaultSuffix}
	/></StreamBankLink>
	
}

